import { render, staticRenderFns } from "./TripViewOrderGrid.vue?vue&type=template&id=c584e11e&scoped=true&"
import script from "./TripViewOrderGrid.vue?vue&type=script&lang=js&"
export * from "./TripViewOrderGrid.vue?vue&type=script&lang=js&"
import style0 from "./TripViewOrderGrid.vue?vue&type=style&index=0&id=c584e11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c584e11e",
  null
  
)

/* custom blocks */
import block0 from "./TripViewOrderGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports